// extracted by mini-css-extract-plugin
module.exports = {"popup":"CheckPreparationBatch__popup--1ix7mLFQs244RrhQfEZeiq"};